<template>
    <div class="layer_wrap">
        <div class="layer_main bd_color echarts_bg_color dp_fs_color">
            <img :src="close" alt="" class="close_btn" @click="closeLayer">
            <div class="layer_head">
                <div class='head_tit'>
                <span class="span_tit pseudo_cls_before">
                    单位风险指数排名
                </span>
                    <span class="fs_12">
                    数据统计时间：{{dateTime}}
                </span>
                </div>
                <ul class="time_set">
                    <li :class="{'pseudo_cls_after': index == 0, 'active': dateInd == index}" v-for="(item, index) in dateArr" :key="index" @click="timeType(index)">
                        {{item}}
                    </li>
                </ul>
            </div>
            <div class="layer_ul_tit bd_color">
                <ul>
                    <li v-for="(item, index) in titArr" :key="index">
                        {{item}}
                    </li>
                </ul>
            </div>
            <div class="layer_ul_wrap" id="list-layer-ul-wrap">
                <ul>
                    <li v-for="(item, index) in dataList" :key="index" class="bd_color" @click="layer_detail(item.recordDate, item.type, item.depId)">
                    <span class="depName">
                        {{item.depName}}
                    </span>
                        <span class="address">
                        {{item.depAddress}}
                    </span>
                        <span class="person">
                        {{item.chargePersonName}}
                    </span>
                        <span class="phone">
                        {{item.chargePersonTel}}
                    </span>
                        <span class="score">
                        {{item.score}}
                    </span>
                        <span class="pic_wrap">
                        <img :src="detail" title="详情" alt="" >
                    </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import detail from "@/assets/img/baogao.png";
    import close from '@/assets/img/close.png';

    import { getTime } from '@/assets/js/index.js';
    export default {
        name:"",
        data: () => ({
            detail: detail,
            close: close,
            dateTime: '',
            dateArr:[
                '周',
                '月'
            ],
            dateInd: 0,
            titArr:[
                '单位名称',
                '单位地址',
                '责任人',
                '联系方式',
                '指数',
                '详情'
            ],
            dataList:[],
            dataCount: 0,
        }),
        props:[
            'layerData'
        ],
        watch: {
            layerData(res){
                if(res && res.data.data.length > 0){
                    this.dataList = this.dataList.concat(res.data.data);
                    this.dataCount = res.data.totalCount;
                    this.dateTime = this.dataList[0].recordDate;
                }
            }
        },
        components: {

        },
        created() {

        },
        mounted() {
            let that = this;
            $JQ('#list-layer-ul-wrap').mCustomScrollbar({
                callbacks:{
                    onTotalScroll:function(){
                        if(that.dataCount == that.dataList.length){
                            //没有更多数据
                            return;
                        }else{
                            console.log('加载更多');
                            that.$emit('loadMore', 1);
                        }
                    }
                }
            });
        },
        computed: {

        },
        methods: {
            closeLayer(){
                this.dataList = [];
                this.$emit('closeLayer', true);
            },
            timeType(index){ //切换时间需要重置一下数据
                this.dateInd = index;
                this.dataList = [];
                this.dataCount = 0;
                this.$emit('timeType', index == 0 ? 'week' : 'month');
            },
            layer_detail(time, type, id){  //获取详情信息，显示弹窗组件
                this.reportStatus = true;
                let _time = time.substring(0, time.indexOf('～'));
                var reportTime = '';
                if(type == 'week'){ //周，传递周一时间
                    reportTime = getTime(_time, 'day');
                }else{
                    reportTime = getTime(_time, 'month');
                }
                let reportData = {
                    time: reportTime,
                    id: id
                }
                this.$emit('dw_reportData', reportData);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .layer_wrap{
        position: fixed;
        left: 50%;
        top: 50%;
        width: 60%;
        height: 45%;
        transform: translate(-50%, -50%);
        // overflow: hidden;
        padding: 8px;
        z-index: 10;
        .layer_main:hover{
            border: 1px solid rgba(28, 146, 200, .7);
        }
        .layer_main{
            height: 100%;
            border: 1px solid;
            box-sizing: border-box;
            padding: 20px;
            font-size: 14px;
            position: relative;
            .close_btn{
                position: absolute;
                right: 0;
                top: 0;
                width: 10px;
                padding: 10px;
                cursor: pointer;
                box-sizing: content-box;
            }
            .fs_12{
                font-size: 12px;
            }
            .layer_head{
                overflow: hidden;
                height: 20px;
                .head_tit{
                    float: left;
                    .span_tit{
                        margin-right: 10px;
                        &::before{
                            content: "";
                            display: inline-block;
                            width: 2px;
                            height: 15px;
                            vertical-align: top;
                            margin-top: 2.5px;
                        }
                    }
                }
                .time_set{
                    float: right;
                    font-size: 0;
                    li{
                        display: inline-block;
                        padding: 0 10px;
                        position: relative;
                        font-size: 14px;
                        opacity: 0.5;
                        cursor: pointer;
                        &::after{
                            content: "";
                            display: inline-block;
                            width: 1px;
                            height: 15px;
                            vertical-align: top;
                            position: absolute;
                            right: 0;
                            top: 2.5px;
                        }
                        &.active{
                            opacity: 1;
                        }
                    }
                }
            }
            .layer_ul_tit{
                height: 40px;
                line-height: 40px;
                margin-top: 20px;
                font-size: 0;
                border-bottom: 1px solid;
                li{
                    display: inline-block;
                    font-size: 14px;
                    text-align: center;
                    padding-left: 10px;
                    box-sizing: border-box;
                    background: rgba(0,45,52,.8);
                }
                li:nth-child(1){
                    width: 20%;
                    text-align: left;
                }
                li:nth-child(2){
                    width: 35%;
                    text-align: left;
                }
                li:nth-child(3){
                    width: 10%;
                }
                li:nth-child(4){
                    width: 15%;
                }
                li:nth-child(5){
                    width: 10%;
                }
                li:nth-child(6){
                    width: 10%;
                }
            }
            .layer_ul_wrap{
                height: calc(100% - 80px);
                overflow: auto;
                li{
                    font-size: 0;
                    border-bottom: 1px solid;
                    cursor: pointer;
                    &:hover{
                        background: rgba(132, 239, 243, .36);
                    }
                    span{
                        font-size: 12px;
                        display: inline-block;
                        height: 40px;
                        line-height: 40px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                    }
                    .depName{
                        width: 20%;
                        text-align: left;
                        padding-left: 10px;
                        box-sizing: border-box;
                    }
                    .address{
                        width: 35%;
                        text-align: left;
                    }
                    .person{
                        width: 10%;
                    }
                    .phone{
                        width: 15%;
                    }
                    .score{
                        width: 10%;
                    }
                    .pic_wrap{
                        width: 10%;
                        img{
                            display: inline-block;
                            vertical-align: middle;
                            cursor: pointer;
                            padding: 10px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/listLayer.vue